import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PrimeNG } from 'primeng/config';
import { TranslateDirective, TranslatePipe, TranslateService } from '@ngx-translate/core';
import { SharedModule } from './shared/shared.module';
import { ServiceWorkerService } from './core/services/serviceworker.service';
import { DkCookieConsentComponent } from './shared/components/dk-cookie-consent/dk-cookie-consent.component';
import { NotificationToastComponent } from './shared/components/notification-toast/notification-toast.component';
import { UpdateNotificationComponent } from './shared/components/update-notification/update-notification.component';
import { NgxEchartsDirective, provideEchartsCore } from 'ngx-echarts';
import * as echarts from 'echarts/core';
import { BarChart, GaugeChart, PieChart } from 'echarts/charts';
import { GraphicComponent, GridComponent, VisualMapComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { AppLoadingService } from './app-loading.service';
echarts.use([BarChart, PieChart, GaugeChart, GraphicComponent, VisualMapComponent, GridComponent, CanvasRenderer]);
@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    TranslatePipe,
    TranslateDirective,
    SharedModule,
    DkCookieConsentComponent,
    NotificationToastComponent,
    UpdateNotificationComponent,
    NgxEchartsDirective
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.less',
  providers: [provideEchartsCore({ echarts })],
})
export class AppComponent implements OnInit {
  title = 'Doktar';

  constructor(
    private primeng: PrimeNG,
    private translateService: TranslateService,
    private serviceWorkerService: ServiceWorkerService,
    public appLoadingService: AppLoadingService
  ) {
    // By this point, languages have been fully initialized
    const currentLang = this.translateService.currentLang;
    console.log(`App component created with language: ${currentLang}`);
  }

  ngOnInit() {
    this.primeng.ripple.set(true);
    this.serviceWorkerService.checkForUpdates();

     // Initialize PrimeNG locale on app start
    this.updatePrimeNGLocale();
    
    // Update PrimeNG locale whenever language changes
    this.translateService.onLangChange.subscribe(() => {
      this.updatePrimeNGLocale();
    });
  }

  private updatePrimeNGLocale() {
    this.translateService.get('primeng').subscribe(translations => {
      this.primeng.setTranslation(translations);
    });
  }
}
